function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#fi)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 35,
  r: 28,
  fill: "currentColor"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.6056 26.1502L45.4807 35.0713C45.639 35.1663 45.7701 35.3011 45.8611 35.4625C45.9521 35.6239 46 35.8063 46 35.992C46 36.1777 45.9521 36.3601 45.8611 36.5215C45.7701 36.683 45.639 36.8177 45.4807 36.9127L30.6084 45.8481C30.4471 45.9453 30.263 45.9978 30.075 45.9999C29.887 46.0021 29.7018 45.954 29.5383 45.8605C29.3748 45.7669 29.2388 45.6313 29.1443 45.4676C29.0497 45.3038 28.9999 45.1176 29 44.9281L29 27.0716C29 26.8824 29.0496 26.6966 29.1439 26.533C29.2383 26.3694 29.3739 26.2339 29.537 26.1403C29.7001 26.0467 29.8849 25.9983 30.0726 26C30.2603 26.0018 30.4442 26.0536 30.6056 26.1502Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "fi",
  x: 0,
  y: 0,
  width: 70,
  height: 70,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 35,
  y1: 7,
  x2: 35,
  y2: 63,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF6F55"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF785F"
})));

var SvgTimerStartBtn = function SvgTimerStartBtn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTimerStartBtn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/timer-start-btn.7984e18d.svg";
export { ForwardRef as ReactComponent };